import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    systemType: "海洋信息",
    allInformationList: null, // 没用上
    regionInformation: null,
    regionValue: null, // 各地区总数
    curRegion: "中国", // 当前选中的地区
    regionMap: {}, // 区域字典：id->name, name->id
    chinaValue: null, // 中国的数据
    regionNameList: null, // 地区名称列表，分domestic/global
    isLogin: false, // 是否已登录
    menuLevel: 1, //菜单等级（1:一级， 2:二级）
    domainMap: null, //领域id信息
    TextStore: "", //知识抽取文本
  },
  getters: {
    getSystemType(state) {
      return state.systemType;
    },

    getAllInformationList(state) {
      return state.allInformationList;
    },

    getRegionInformation(state) {
      return state.regionInformation;
    },

    getRegionValue(state) {
      return state.regionValue;
    },

    getRegionMap(state) {
      return state.regionMap;
    },

    getCurRegion(state) {
      return state.curRegion;
    },

    getChinaValue(state) {
      return state.chinaValue;
    },

    getRegionNameList(state) {
      return state.regionNameList;
    },

    getIsLogin(state) {
      return state.isLogin;
    },

    getTextStore(state) {
      return state.TextStore;
    },
  },
  mutations: {
    setMenuLevel(state, val) {
      state.menuLevel = val;
    },

    setSystemType(state, val) {
      state.systemType = val;
    },

    setAllInformationList(state, val) {
      state.allInformationList = val;
    },

    setRegionInformation(state, val) {
      state.regionInformation = val;
    },

    setRegionValue(state, val) {
      state.regionValue = val;
    },
    setRegionMap(state, val) {
      state.regionMap = val;
    },

    setCurRegion(state, val) {
      state.curRegion = val;
    },

    setChinaValue(state, val) {
      state.chinaValue = val;
    },

    setRegionNameList(state, val) {
      state.regionNameList = val;
    },

    setIsLogin(state, val) {
      state.isLogin = val;
    },

    setDomainMap(state, val) {
      state.domainMap = val;
    },

    setTextStore(state, val) {
      state.TextStore = val;
    },
  },
  actions: {},
  modules: {},
});
